import { render, staticRenderFns } from "./editChange.vue?vue&type=template&id=1cc99820&scoped=true"
import script from "./editChange.vue?vue&type=script&lang=js"
export * from "./editChange.vue?vue&type=script&lang=js"
import style0 from "./editChange.vue?vue&type=style&index=0&id=1cc99820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc99820",
  null
  
)

export default component.exports